// extracted by mini-css-extract-plugin
module.exports = {"miniCardV2":"MiniCardV2_miniCardV2__B4x20","tagline":"MiniCardV2_tagline__7fsnd"};